import { createFileRoute } from "@tanstack/react-router";
import ReferYourEmployer from "@/pages/ReferYourEmployer";

const URL = "https://www.homeapproach.com/refer-your-employer";
const TITLE = "Refer Your Employer — Earn 20% Ongoing | Home Approach";
const DESC = "Bring Home Approach to your employer. When they become a paying customer, members earn 20% of what they pay, every quarter, for as long as they stay.";

export const Route = createFileRoute("/refer-your-employer")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "website" },
      { property: "og:url", content: URL },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: () => <ReferYourEmployer />,
});
